<template>
  <div>
    <q-form @submit="onSubmit" class="form">
      <div class="form__item">
        <CustomInput
          label="Название"
          :required="true"
          placeholder="Введите название группы"
          :value="formData.work_set_check_group_name || ''"
          @change_input="value => onChange('work_set_check_group_name', value)"
        />
      </div>
      <CustomModalFooter
        :btn-loading="loading"
        :on-submit="onSubmit"
        submit-btn-text="Добавить группу"
      />
    </q-form>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import CustomInput from '@/components/form/CustomInput'
import CustomModalFooter from '@/components/modal/modals/modal-footer'
import { useCustomSnackbar } from '@/_helpers/hooks/useCustomSnackbar'
import { addGroupConstructive } from '@/views/PackageEntry/services'

const props = defineProps({
  data: {
    type: Object,
    default: () => ({})
  },
  closeModal: {
    type: Function,
    default: () => {}
  }
})

const { showSucceedSnackbar, showErrorSnackbar } = useCustomSnackbar()

const loading = ref(false)
const formData = ref({
  work_set_check_group_name: '',
})

const onChange = (field, value) => {
  formData.value[field] = value
}

const closeModal = () => {
  props.closeModal()
}

const onSubmit = async () => {
  loading.value = true
  
  const res = await addGroupConstructive(formData.value)
  if (!res || !Array.isArray(res) || !res.length) {
    loading.value = false
    showErrorSnackbar('Не удалось создать группу')
    return
  }
  showSucceedSnackbar()
  const row = res[0]
  if (props.data?.onClose) {
    props.data.onClose(row.work_set_check_group_id, row.work_set_check_group_name ?? formData.value.work_set_check_group_name)
  }
  
  closeModal()
  loading.value = false
}
</script>

<style scoped lang="scss">
.form {
  display: flex;
  flex-direction: column;
  gap: 20px;

  &__item {
    display: flex;
    flex-direction: column;
  }
}
</style>